import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { Link } from "react-router-dom";

import Button from "material-ui/Button";
import Typography from "material-ui/Typography";

import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import FilterTabs from "../../../common/FilterTabs";

import Loader from "../../../Parts/Loader";
import NotificationBar from "../../../Parts/NotificationBar.jsx";

import ArrowLeft from "../../../Icons/ArrowLeft";
import ProgressBar from "../common/ProgressBar";
import SalesforceExeExportMapping from "./SalesforceExeExportMapping";
import SalesforceSettingComplete from "../common/SalesforceSettingComplete";
import ExeMappingTable from "./ExeMappingTable";
import {
  salesforceExeSettingSteps,
  salesforceExeExportMappingFormProps,
  SalesforceSettingDirectory,
  DialogType,
  SalesforceExeSettingStep,
  SalesforceExportMappingFrom,
  SalesforceExeExportObjectType,
} from "../../../../constants/ComponentTypes";
import { makeSalesforceExportMap } from "../../../../utils/utils";

const { Map } = require("immutable");

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  overview: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  returnBtn: {
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
  },

  heading: {
    width: "100%",
    marginTop: "14px",
  },

  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "30px",
  },

  body: {
    width: "100%",
    margin: "40px 0px 90px 0px",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "36px",
  },

  field: {
    marginBottom: "36px",
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "24px",
  },

  settingButton: {
    color: "#1A65FF",
    fontSize: "13px",
    fontWeight: "bold",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
    padding: "1px",
    marginLeft: "18px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

class SalesforceExeSetting extends React.Component {
  state = {
    sobject_name: SalesforceExeExportObjectType.CONTACT.value,
    step: SalesforceExeSettingStep.OVERVIEW,
    showNotification: false,
    message: "",
    messageType: "success",
    mapping: Map(),
  };

  componentDidMount() {
    this.props.getUserInfo();
    this.props.getSalesforceDescribeExeExport();
    this.props.getSalesforceExportMappings({
      type: SalesforceExportMappingFrom.EXE.value,
    });

    let mapping = this.state.mapping;
    salesforceExeExportMappingFormProps.forEach((prop) => {
      mapping = mapping.set(prop.key, {});
    });
    this.setState({
      sobject_name:
        this.props.mapping &&
          this.props.mapping.hasOwnProperty(
            SalesforceExeExportObjectType.LEAD.value
          )
          ? SalesforceExeExportObjectType.LEAD.value
          : SalesforceExeExportObjectType.CONTACT.value,
      mapping: mapping,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successMessage && nextProps.successMessage !== "") {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== "") {
      this.displayNotification(nextProps.shortMessage, "green");
    }

    if (this.props.isLoadingMapping && !nextProps.isLoadingMapping) {
      this.setState({
        sobject_name: nextProps.mapping.hasOwnProperty(
          SalesforceExeExportObjectType.LEAD.value
        )
          ? SalesforceExeExportObjectType.LEAD.value
          : SalesforceExeExportObjectType.CONTACT.value,
        mapping: makeSalesforceExportMap(nextProps.mapping),
      });
    }
  }

  /*** toggle funcions ***/
  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  /*** handlers ***/
  goToStep = (step) => {
    this.setState({ step: step });
  };

  handleTabClicked = (value) => {
    let directory = Object.values(SalesforceSettingDirectory).find(
      (item) => item.value === value
    );
    this.props.goTo(directory.setting_path);
  };

  handleUpdateMapping = (mapping) => {
    this.setState({
      mapping: mapping,
    });
  };

  /*** render functions ***/
  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderLoading = () => (
    <div className={this.props.classes.box}>
      <Loader type="color" />
    </div>
  );

  renderError = () => {
    const { classes } = this.props;

    if (this.props.expiredAccessError) {
      return (
        <div className={classes.box} style={{ minHeight: "unset" }}>
          <Typography variant="subheading">
            認証情報が失効しています。
            <a
              href={
                process.env.REACT_APP_API_BASE_URL +
                "/oauth2/salesforce?redirect_url=" +
                process.env.REACT_APP_FRONTEND_URL +
                "/setting/integrations/salesforce"
              }
              target="_self"
              className={classes.link}
            >
              こちら
            </a>
            より再設定してください。
          </Typography>
        </div>
      );
    } else {
      return (
        <div className={classes.box} style={{ minHeight: "unset" }}>
          <Typography variant="subheading">
            キーマンデータベース連携が設定されていません。
            <Link
              to={SalesforceSettingDirectory.EXE_LIST.setup_path}
              className={classes.link}
            >
              こちら
            </Link>
            で設定してください。
          </Typography>
        </div>
      );
    }
  };

  renderOverview = () => {
    const { classes, isLoadingMapping, isLoadingFields } = this.props;

    return (
      <div className={classes.overview}>
        <div
          className={classes.progressbar}
          style={{ justifyContent: "flex-start" }}
        >
          <Button
            className={classes.returnBtn}
            onClick={() => this.props.goTo(`/setting/integrations/salesforce`)}
          >
            <ArrowLeft
              color="#71737B"
              width={14}
              height={14}
              style={{ marginRight: "6px" }}
            />
            <span>戻る</span>
          </Button>
        </div>
        <div className={classes.heading}>
          <Typography variant="title" className={classes.title}>
            Salesforce連携設定
          </Typography>

          <FilterTabs
            value={this.props.tab}
            handleTabClicked={this.handleTabClicked}
            tabValues={Object.values(SalesforceSettingDirectory)}
          />
        </div>
        <div className={classes.body}>
          {(() => {
            if (isLoadingMapping || isLoadingFields) {
              return this.renderLoading();
            } else if (
              !isLoadingMapping &&
              Object.keys(this.props.mapping).length === 0
            ) {
              return this.renderError();
            } else {
              return (
                <div className={classes.box}>
                  <Typography
                    variant="display1"
                    className={classes.sectionTitle}
                    style={{ marginBottom: "48px" }}
                  >
                    キーマンデータベース連携設定
                  </Typography>

                  <div className={classes.field}>
                    <div className={classes.row}>
                      <Typography
                        variant="title"
                        className={classes.sectionTitle}
                        style={{ marginBottom: "0px" }}
                      >
                        Salesforceオブジェクト
                      </Typography>
                    </div>
                    <Typography
                      variant="subheading"
                      className={classes.fieldDesc}
                    >
                      {this.state.sobject_name ===
                        SalesforceExeExportObjectType.LEAD.value
                        ? SalesforceExeExportObjectType.LEAD.text
                        : "取引先・取引先責任者"}
                    </Typography>
                  </div>

                  <div className={classes.field}>
                    <div className={classes.row}>
                      <Typography
                        variant="title"
                        className={classes.sectionTitle}
                        style={{ marginBottom: "0px" }}
                      >
                        項目マッピング
                      </Typography>
                      <Button
                        color="primary"
                        className={classes.settingButton}
                        onClick={() =>
                          this.goToStep(SalesforceExeSettingStep.MAPPING)
                        }
                      >
                        設定する
                      </Button>
                    </div>
                    <Typography
                      variant="body2"
                      style={{ marginBottom: "43px" }}
                    >
                      Salesforce・Keyman
                      Letter間で同期を自動化するための項目マッピングを設定します。マッピングが定義された状態で、「注文履歴」画面で「Salesforceに同期」を選択すると、キーマンデータベースからのレター注文はKeyman
                      LetterからSalesforceのキャンペーンに、注文済みキーマンはSalesforceの指定オブジェクトに、同期されます。
                    </Typography>

                    <ExeMappingTable
                      step={this.state.step}
                      sobject={this.state.sobject_name}
                      mapping={this.state.mapping}
                      enableEdit={false}
                      disabled={this.props.isConfiguring}
                      updateMapping={this.handleUpdateMapping}
                      isLoadingFields={this.props.isLoadingFields}
                      accountFields={this.props.accountFields}
                      contactFields={this.props.contactFields}
                      leadFields={this.props.leadFields}
                    />
                  </div>
                </div>
              );
            }
          })()}
        </div>
      </div>
    );
  };

  renderEditMapping = () => (
    <SalesforceExeExportMapping
      step={this.state.step}
      type={DialogType.EDIT}
      sobject={this.state.sobject_name}
      mapping={this.state.mapping}
      updateMapping={this.handleUpdateMapping}
      isLoadingFields={this.props.isLoadingFields}
      isConfiguring={this.props.isConfiguring}
      accountFields={this.props.accountFields}
      contactFields={this.props.contactFields}
      leadFields={this.props.leadFields}
      goToStep={this.goToStep}
      postSalesforceExportMappingsExe={
        this.props.postSalesforceExportMappingsExe
      }
      goBack={() => this.goToStep(SalesforceExeSettingStep.OVERVIEW)}
    />
  );

  render() {
    const { classes } = this.props;

    let notification;
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }

    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle="キーマンデータベース連携設定"
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() =>
            this.props.goTo("/setting/integrations/salesforce")
          }
        />
        <div className={classes.content}>
          {(() => {
            if (this.state.step === SalesforceExeSettingStep.OVERVIEW) {
              return this.renderOverview();
            } else if (
              this.state.step === SalesforceExeSettingStep.SETTING_COMPLETE
            ) {
              return (
                <SalesforceSettingComplete
                  goTo={this.props.goTo}
                  type={SalesforceSettingDirectory.EXE_LIST.value}
                  dialogType={DialogType.EDIT}
                  isImporting={this.props.isImporting}
                />
              );
            } else {
              return (
                <div>
                  <div className={classes.progressbar}>
                    <ProgressBar
                      step={this.state.step}
                      steps={salesforceExeSettingSteps}
                    />
                  </div>
                  {(() => {
                    if (
                      this.state.step === SalesforceExeSettingStep.MAPPING ||
                      this.state.step === SalesforceExeSettingStep.PREVIEW
                    ) {
                      return this.renderEditMapping();
                    }
                  })()}
                </div>
              );
            }
          })()}
        </div>
        {notification}
      </Wrapper>
    );
  }
}

SalesforceExeSetting.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  message: PropTypes.string,
  messageType: PropTypes.string,
  isLoading: PropTypes.bool,
  isImporting: PropTypes.bool,
  isConfiguring: PropTypes.bool,
  isLoadingMapping: PropTypes.bool,
  isLoadingFields: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  expiredAccessError: PropTypes.bool,
  mapping: PropTypes.object,
  accountFields: PropTypes.object,
  contactFields: PropTypes.object,
  leadFields: PropTypes.object,
  tab: PropTypes.number,
  goTo: PropTypes.func,
  getUserInfo: PropTypes.func,
  getSalesforceDescribeExeExport: PropTypes.func,
  getSalesforceExportMappings: PropTypes.func,
  postSalesforceExportMappingsExe: PropTypes.func,
};

export default withStyles(styles)(SalesforceExeSetting);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceExeSetting/SalesforceExeSetting.jsx